import { Link as MuiLink, LinkProps as MuiLinkProps } from '@mui/material';
import { styled } from '@mui/material/styles';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { WsColors } from 'wisestep-base';

const StyledLink = styled(MuiLink)(() => ({
  color: WsColors.TheBlues750,
  textDecoration: 'none',
  cursor: 'pointer',

  '& *': {
    cursor: 'inherit',
    color: 'inherit',
  },

  '&:hover': {
    textDecoration: 'underline',
    textDecorationColor: WsColors.TheBlues750,
  },
  '&:focus': {
    textDecoration: 'underline',
    textDecorationColor: WsColors.TheBlues750,
    outline: `2px solid ${WsColors.LinkOutline}`,
  },
  '&:active': {
    textDecoration: 'underline',
    textDecorationColor: WsColors.LinkActive,
  },
  '&:visited': {
    color: WsColors.TheBlues750,
  },
  '&.Mui-disabled': {
    color: 'grey',
    pointerEvents: 'none',
    textDecoration: 'none',
    cursor: 'default',
  },
}));

const WsLink = (props, ref) => <StyledLink component={RouterLink} to="./" ref={ref} {...props} />;

export default React.forwardRef<HTMLAnchorElement, MuiLinkProps & { to?: string }>(WsLink);
